import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";
import axios from "axios";
// 列表查询
export function querySeekSupplierPage(data) {
  return request({
    url: "/apis/ebs/spc/seek/querySeekSupplierPage",
    method: "post",
    data
  });
}

export function seekClassify() {
  const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);
  return axios.create().get(baseURL + "/apis/ebs/spc/seek/seekClassify");
}
